import System from "./Components/System";

function App() {
	return (
		<div className="App">
			<System />
		</div>
	);
}

export default App;
